import { render, staticRenderFns } from "./ALoader.vue?vue&type=template&id=5c14850e&scoped=true"
import script from "@/components/loader-card/LoaderCard.ts?vue&type=script&lang=ts&external"
export * from "@/components/loader-card/LoaderCard.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/loader-card/loader-card.scss?vue&type=style&index=0&id=5c14850e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c14850e",
  null
  
)

export default component.exports